import { gql } from 'graphql-tag'

const FRAGMENT_CONVERSATION_TITLE_USER = gql`
  fragment ConversationTitleUser on user {
    id
    virtual_display_name
  }
`

export const FRAGMENT_CONVERSATION_TITLE_CONVERSATION = gql`
  fragment ConversationTitleConversation on conversation {
    id
    type
    created_at
    conversation_users {
      user {
        ...ConversationTitleUser
      }
    }
    current_conversation_user: conversation_users(where: { user_id: { _eq: $currentUserId } }) {
      id
      archived_at
    }
    session {
      id
      title
      session_hosts {
        role
        user {
          ...ConversationTitleUser
        }
      }
    }
    series {
      id
      title
      series_hosts {
        role
        user {
          ...ConversationTitleUser
        }
      }
    }
  }
  ${FRAGMENT_CONVERSATION_TITLE_USER}
`
